import apiClient from './authService';
import { buildAddProductFormData } from './buildAddProductFormData';

export function getAllProductsCatalog(businessId) {
  return apiClient
    .get(`/products/${businessId}/master-products/`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch products catalog'
        );
      }

      throw new Error('Network error');
    });
}



export function addBusinessProduct(data) {
  const formData = buildAddProductFormData(data);

  return apiClient
    .post('/business-products/create/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to add product');
      }

      throw new Error('Network error');
    });
}